import styled from 'styled-components'

import typeStyle from '../../styles/typeStyle'

export const TagWrapper = styled.div`
  ${typeStyle('-ds-font-body-light')}
  display: inline-flex;
  align-items: center;
  padding: 12px;

  line-height: 1;

  color: #1d1d1d;
  background-color: ${({ theme }) => theme.brand.sand};
  border-radius: 5px;

  .icon {
    display: inline-block;
    vertical-align: middle;

    font-size: 24px;
    margin-right: 8px;
  }

  ${({ theme, sunUp }) =>
    sunUp &&
    `
    background-color: ${theme.brand.sunup};
  `}

  ${({ disabled }) =>
    disabled &&
    `
    color: #979797;

    span {
      text-decoration: line-through;
    }
  `}

  ${({ active, theme }) =>
    active &&
    `
    color: white;
    background-color: ${theme.brand.jungle};
  `}
`

export default ({ icon, children, ...props }) => (
  <TagWrapper {...props}>
    <i className={`icon icon-${icon}`} />
    <span>{children}</span>
  </TagWrapper>
)
